<template>
  <b-dropdown split text="Add card" @click="$emit('add-card')">
    <b-dropdown-item-button
      v-for="card in cards"
      :key="card.slug"
      @click="$emit('add-card', card)"
    >
      {{ card.title }}
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  name: "DeckEditorAddCardButton",
  computed: {
    cards() {
      return this.$store.state.umDbCardList
        .filter(x => x.decks.length > 1)
        .sort((a, b) => {
          return (
            b.decks.length - a.decks.length || a.title.localeCompare(b.title)
          );
        });
    }
  }
};
</script>
